import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { env } from "@environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class SubDistributionDozController {
  public constructor(httpService: HttpClient) {
    this.httpService = httpService;
  }

  httpService: HttpClient;
  protected baseUrl = `${env.logisticsServiceBackend}/logistics/v1/sub/distributions/doz`;

  public createSubDistribution(beneficiaryIds: number[]): Observable<any>  {
    const headers = new HttpHeaders().set("Content-type", "application/json");
    return this.httpService.post(`${this.baseUrl}/create`, JSON.stringify(beneficiaryIds), { headers, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public getSubDistribution(id: number): Observable<any> {
    return this.httpService.get(`${this.baseUrl}/${id}`, { responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public getSubDistributions(id: number): Observable<any> {
    return this.httpService.get(`${this.baseUrl}/all/${id}`, { responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public sendToAgreement(id: number): Observable<any> {
    return this.httpService.put<void>(`${this.baseUrl}/agreement/${id}`, { responseType: "text" });
  }

  public completeDistribution(id: number): Observable<any> {
    return this.httpService.put<void>(`${this.baseUrl}/complete/${id}`, { responseType: "text" });
  }

  public returnToReworking(id: number): Observable<any> {
    return this.httpService.put<void>(`${this.baseUrl}/reworking/${id}`, { responseType: "text" });
  }

  public archive(id: number): Observable<any> {
    return this.httpService.put<void>(`${this.baseUrl}/archive/${id}`, { responseType: "text" });
  }

  public updateRemnants(id: number): Observable<any> {
    return this.httpService.put<void>(`${this.baseUrl}/update/remnants/${id}`, { responseType: "text" });
  }

  public updateRequisitions(id: number): Observable<any> {
    return this.httpService.put<void>(`${this.baseUrl}/update/requisitions/${id}`, { responseType: "text" });
  }
}
